import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function slogansSlider() {
  const sliders = document.querySelectorAll(".slogans-slider");
  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      effect: "fade",
      speed: 1000,
      fadeEffect: {
        crossFade: true,
      },
    });
  });
}

export { slogansSlider };
